import React, { useEffect, useMemo, useState, useCallback, use, useRef,  } from 'react';
import PageHeader from '../components/PageHeader';
import StatCard from '../components/StatCard';
import Button from '../components/Button';
import Input from '../components/Input';
import { format, isPast, parseISO } from 'date-fns';
import Select from '../components/Select';
import Chip from '../components/Chip';
import {  createLicense, deleteLicense, GetLicensesList, RefrechLicense,changesubscriberLicensefvOrNot, SendLicense,ClearDatabasePOST,GetLicensesListGenereatedTest,UpdateActivationCompetitionProduct, DisableSubscription,getExportList, RenwSubscription, updateLicense, SendEmail, SaveIntegraationData, SaveAditionalModuleData, SetFVRozliczenie, SendOneMoreTime, createKeyList, GetLicensesListGenereated } from '../api/licenses';
import { GetCompetitionProds, GetBrandlyData,removeAddedUser, GetAdedUsersToIndex,GetAddedIndexToUser, saveUserIndex } from '../api/Repricing/repricing';
import { pl } from 'date-fns/locale';
import { BsHourglass } from 'react-icons/bs';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../components/Dialog';
import Snackbar from '../components/Snackbar';
import { useAuth } from '../store/auth';
import Table from '../components/Table';
import PageHeaderPortal from '../components/PageHeaderPortal';
import BrandlyServiceComponent from '../components/BrandlyServiceComponent';
import CompetitionUsersAdded from '../components/Dialogs/Brandly/CompetitionUsersAddes';
import CompetitionAddUser from '../components/Dialogs/Brandly/CompetitionAddUser';
import CompetitionSearchUsers from '../components/Dialogs/Brandly/CompetitionSearchUsers';
import CsvUpload from '../components/Dialogs/Brandly/CsvUpload';
import CompetitionUserIndexList from '../components/Dialogs/Brandly/CompetitionUserIndexList';
export default function PriceConcurent() {
    const { user, logout } = useAuth();
    const [options, setOptions] = useState({ licensesList: [], companies: [], users: [] , vendorList: [], integracje: [], needFV: [], rptList: []});
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    let logedUser = useAuth((state) => state.user);
    const [q, setQ] = useState('');
    const [searchEan, setSearchEan] = useState('');
    const [searchName, setSearchName] = useState('');

    const [selectedUser, setSelectedUser] = useState({});
    const [SelectedCSV,setSelectedCSV] = useState(null);
    const [rows, setRows] = useState([]);
    const [params, setParams] = useState({ page: 1, limit: 100, searchEan:'', searchName:'' });
    const [brandlyData, setBrandlyData] = useState(null);
    const [isActivate, setisActivate] = useState('all'); 
    const [isPrzypisane, setisPrzypisane] = useState('all'); 

    
     const [loading, setLoading] = useState(true); 

     const [editing, setEditing] = useState([]);
          const [indexList, setIndexList] = useState([]);

     const [AddindexToUser, setAddindexToUser] = useState([]);
          const [selectedUserToTakeData, setselectedUserToTakeData] = useState({});


          const clearSearchData = () => {
            setSearchEan('');
            setSearchName('');
            setisActivate('all');
            setisPrzypisane('all');
            setParams(prev => ({ ...prev, page: 1, searchEan: '', searchName: '', isActive: 'all', isPrzypisane: 'all' }));
           
           
          }
             const startScan = async () => {
            const response = await fetch("https://hs2api.razamit.pl/RunDataApiBrandly", {
      credentials: "include",
      method: "GET",
     
      
    }); setToast({ open: true, message: "Zainicjowano pobieranie danych", severity: "info" });
          }
          const uploadFile = async () => {
            if (!SelectedCSV) return;
          const selectedUserId = selectedUser?.id;
          if (!selectedUserId) {
            console.error("Brak wybranego użytkownika.");
            return;
          }
    const formData = new FormData();
    formData.append("csv", SelectedCSV);
    formData.append("userId", selectedUserId);

    const response = await fetch("https://hs2api.razamit.pl/uploadconcurentsToUser", {
      credentials: "include",
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    setOpenAddMultiIndex(false);
    setToast({ open: true, message: data.message, severity: data.status });
   // console.log(data);
  };
     const [open, setOpen] = useState(false);
     const [openAdduser, setOpenAddUser] = useState(false);
          const [openuserAllIndex, setopenuserAllIndex] = useState(false);
          const [openuserIndexForUser, setopenuserIndexForUser] = useState(false);
          const [selectedAddedUserProdId, setselectedAddedUserProdId] = useState(0);

     const [openAddMultiIndex, setOpenAddMultiIndex] = useState(false);
     const onEdit = useCallback(async (row) => {
         //setEditing(row);
         setLoading(true);
         const data = await fetchAdedUsersToIndex(row.id);
         setselectedAddedUserProdId(row.id);
         console.log("Fetched data for editing:", data);
         setEditing(data.data);
         //setForm({ client_email: row.client_email, shop_name: row.shop_name, nip: row.nip, shop_phone: row.shop_phone, licenseId: row.licenseId, license_name: row.license_name, licDays: row.licDays , userID:row.userID});
         setOpen(true);
         setLoading(false);
       }, []);
       const indexUserListGet = useCallback(async (userId) => {
         //setEditing(row);
        
         console.log("Fetching index list for user:", userId);
         setLoading(true);
         const data = await GetAddedIndexToUser(userId);
         console.log("Fetched data for editing:", data);
         setIndexList(data.data);
         setLoading(false);
         setopenuserIndexForUser(true);
       }, []);
       
       const saveUserToIndexTakeData = useCallback((userId) => {
         //setEditing(row);
       setLoading(true);
       console.log("Saving user to index:", userId);
       setselectedUserToTakeData(userId);
       setLoading(false);
        setopenuserAllIndex(false);
        setToast({ open: true, message: "Wczytano indeksu użytkownika", severity: "success" });

        indexUserListGet(userId);
       }, []);
    const saveUserToIndex = useCallback(async (userId) => {
         //setEditing(row);
        // setLoading(true);
        console.log("Saving user to index:", userId, AddindexToUser.id);
         const data = await saveUserIndex(userId, AddindexToUser.id);
        // setLoading(false);
        setOpenAddUser(false);
               setToast({ open: true, message: "Zapisano dane", severity: "success" });

       }, [AddindexToUser]);

         const onSetUser = useCallback(async (row) => {
         //setEditing(row);
                 console.log("Saving user to index:", row);

         setAddindexToUser(row);
         setLoading(true);
        // const data = await fetchAdedUsersToIndex(row.id);
       //  console.log("Fetched data for editing:", data);
       //  setEditing(data.data);
         //setForm({ client_email: row.client_email, shop_name: row.shop_name, nip: row.nip, shop_phone: row.shop_phone, licenseId: row.licenseId, license_name: row.license_name, licDays: row.licDays , userID:row.userID});
         setOpenAddUser(true);
         setLoading(false);
       }, []);
       
     const searchDataEan = () => {
        setParams(prev => ({ ...prev, page: 1, searchEan: searchEan }));
        fetchCOmpetitionData();
      }
     const searchDataName = () => {
    setParams(prev => ({
        ...prev,
        page: 1,
        searchName: searchName,
        searchEan: searchEan,
        isActivate: isActivate,
        isPrzypisane: isPrzypisane
    }));
};

     useEffect(() => {
        // fetchData();
         //fetchBrandlyData();
       }, []);

       const loaded = useRef(false);


useEffect(() => {

    if (loaded.current) {
        return;
    }
    loaded.current = true;
    const loadData = async () => {
        setLoading(true);
        try {
            await fetchCOmpetitionData();
        } catch (err) {
            console.error("Fetch error:",err);
        } finally {
            setLoading(false);
        }
    };
    loadData();
}, [params]);

const loadNewData = async (page,limit) => {
  

    setParams(prev => ({ ...prev, page, limit }));
  
}
useEffect(() => {
    
    fetchCOmpetitionData();
}, [params.page, params.limit, params.searchEan, params.searchName, params.isActivate, params.isPrzypisane]);

const fetchAdedUsersToIndex = async (indexId) => {
    try {
      const  data  = await GetAdedUsersToIndex(indexId);
       return data;
    } catch (error) {
      console.error("Error fetching added users:", error);
    }
}


      const fetchCOmpetitionData = async () => {
        try {
            setLoading(true);
          const d = await GetCompetitionProds(params.page, params.limit, searchEan, params.searchName, params.isActivate, params.isPrzypisane);
          setBrandlyData(d);
          setLoading(false);
        
        } catch (error) {
            setLoading(false);
          console.error("Error fetching competition data:", error);
            if (error.message.includes("token")) {
           setRows([]); 
           window.location.href = "/login"; 
           return;
            }
        }
      };
useEffect(() => {
   
}, [brandlyData]);
     
const fetchBrandlyData = async () => {
        try {
          const data = await GetBrandlyData(1,50);
         
        } catch (error) {
          console.error("Error fetching Brandly data:", error);
        }
        };
const onChangeAc = (product) => {


   setBrandlyData(prev => ({
    ...prev,
    dane: prev.dane.map(item =>
        item.id === product.id

            ? {
                ...item,
                isActive: item.isActive === "0" ? "1" : "0"
            }
            : item
    )
}));
const update = async () => {
  const result = await UpdateActivationCompetitionProduct(product.id, product.isActive === "0" ? "1" : "0");
  return result;
};
update().then(() => {
        setToast({ open: true, message: "Zapisano zmiany na indeksie", severity: "success" });
});
};
      const fetchData = async (filter= "p") => {
       setLoading(true);
     
       try {
         const data = await GetLicensesList(filter);
     
         if (!data || data.error) {
           throw new Error(data?.error || "Błąd serwera");
         }
     
         const mapped = data.data.map(item => ({
           id: item.subscriber_id,
           name: item.license_name,
           client_email: item.client_email,
           accountManager: item.us_name,
           shop_expireDate: item.shop_expireDate,
           last_login: item.last_login,
           login_data: item.login_data,
           shop_name: item.shop_name,
           active: item.active,
           nip: item.nip,
           shop_phone: item.shop_phone,
           licenseId: item.licenseId,
           license_name: item.license_name,
           licDays: item.licDays,
           newAcount: item.newAcount,
           userID: item.UserId,
           vendorId: item.vendorId,
           integrationIds: item.integrationIds,
           CompnyName: item.CompnyName,
           renewals_count: item.renewals_count,
           needFV: item.needFV,
           NoneedFV: item.NoneedFV,
           needFvTagedToExport: item.needFvTagedToExport,
           license_number: item.license_number ?? "-",
           subscriber_id: item.subscriber_id,
           user_want_use: item.user_want_use,
           counttofv: item.counttofv,
           access_ids: item.access_ids,
         }));
     
         setRows(mapped);
     
       } catch (err) {
         console.error("Fetch error:", err.message);
     
      
         if (err.message.includes("token")) {
           setRows([]); 
           window.location.href = "/login"; 
           return;
         }
       } finally {
         setLoading(false);
       }
     };
    
    const removeUserFromCompetition = async (userId, indexid) => {

      const dd = await removeAddedUser(userId, indexid);
  // const response = await fetch(`/api/competition/users/${userId}`, {
  //   method: "DELETE",
  // });

  // if (!response.ok) {
  //   throw new Error("Nie udało się usunąć użytkownika");
  // }

  setEditing((prevUsers) =>
    prevUsers.filter((user) => user.user_id !== userId)
  );
};
   
   

  


  return (
    <div className="flex flex-col h-[calc(100vh-170px)]">
      <PageHeaderPortal title="Integracja cen konkurencjii" subtitle="Zarządzanie integracjami cen konkurencji od dostawców" 
        actions={
          <div className='grid grid-cols-2 md:grid-cols-[auto_auto_1fr] gap-2 items-end '>
                  <Button className="h-fit self-end sm:w-auto mb-3" variant="contained" size="small" onClick={()=>{setopenuserAllIndex(true); setselectedUserToTakeData('');}} >Indeksy użytkownika</Button>
                      <Button className="h-fit self-end sm:w-auto mb-3" variant="contained" size="small" onClick={()=>{setOpenAddMultiIndex(true);setSelectedCSV(null); setSelectedUser('');}} >Wstaw globalnie</Button>
                      <Button className="h-fit self-end sm:w-auto mb-3" variant="contained" size="small" onClick={()=>{startScan()}} >Wymuś pobieranie</Button>
                      </div>
            }
      
      />

      <Dialog open={open} onClose={() => setOpen(false)} width="w-[500px]">
              <DialogTitle>{editing ? 'Lista przypisanych użytkowników' : 'Nowa licencja'}</DialogTitle>
              <DialogContent>
                <div className="space-y-4 mt-2">
                <CompetitionUsersAdded indexId={selectedAddedUserProdId} users={editing || []}  onRemoveUser={removeUserFromCompetition} />
                </div>
              </DialogContent>
              <DialogActions>
                <Button size='medium' onClick={() => setOpen(false)} variant="outlined">Zamknij</Button>
                
                {/* <Button size='medium' onClick={() => setOpen(false)} variant="outlined">Anuluj</Button>
                <Button size='medium' onClick={submitForm} variant="contained" color='success'>Zapisz</Button> */}
              </DialogActions>
              </Dialog>
              
              <Dialog open={openuserAllIndex} onClose={() => setopenuserAllIndex(false)} width="w-[500px]">
              <DialogTitle>{AddindexToUser ? 'Znajdź indeksy przypisane do użytkownika' : 'Nowa licencja'}</DialogTitle>
              <DialogContent>
                <div className="space-y-4 mt-2">
                   <CompetitionSearchUsers getfoundUsers={(selectedUser)=>saveUserToIndexTakeData(selectedUser.id)}/>
                </div>
              </DialogContent>
              <DialogActions>
                <Button size='medium' onClick={() => setopenuserAllIndex(false)} variant="outlined">Zamknij</Button>
              </DialogActions>
              </Dialog>
    <Dialog open={openuserIndexForUser} onClose={() => setopenuserIndexForUser(false)} width="w-[500px]">
              <DialogTitle>{AddindexToUser ? 'Lista indeksów użytkownika' : 'Nowa licencja'}</DialogTitle>
              <DialogContent>
                <div className="space-y-4 mt-2">
                  <CompetitionUserIndexList users={indexList || []} />
                </div>
              </DialogContent>
              <DialogActions>
                <Button size='medium' onClick={() => setopenuserIndexForUser(false)} variant="outlined">Zamknij</Button>
              </DialogActions>
              </Dialog>

              <Dialog open={openAdduser} onClose={() => setOpenAddUser(false)} width="w-[500px]">
              <DialogTitle>{AddindexToUser ? 'Przypisz indeksy do użytkownika' : 'Nowa licencja'}</DialogTitle>
              <DialogContent>
                <div className="space-y-4 mt-2">
                   <CompetitionAddUser users={options.users || []} row={AddindexToUser} saveUserToIndex={saveUserToIndex} />
                {/* <CompetitionUsersAdded users={editing || []} /> */}
                </div>
              </DialogContent>
              <DialogActions>
                                <Button size='medium' onClick={() => setOpenAddUser(false)} variant="outlined">Zamknij</Button>
                
                {/* <Button size='medium' onClick={() => setOpen(false)} variant="outlined">Anuluj</Button>
                <Button size='medium' onClick={submitForm} variant="contained" color='success'>Zapisz</Button> */}
              </DialogActions>
              </Dialog>
              
              <Dialog open={openAddMultiIndex} onClose={() => {setOpenAddMultiIndex(false);}} width="w-[500px]">
              <DialogTitle>Dodaj wiele indeksów do użytkownika</DialogTitle>
              <DialogContent>
                <div className="space-y-4 mt-2">
                    <div className='grid grid-cols-[1fr_auto]'>
                    <p className='block text-xs font-normal text-gray-400 mb-1'>Wybrano użytkownika: </p>
                    <p className='block text-xs font-normal text-gray-400 mb-1'>{selectedUser?.shop_name || "Brak wyboru"}</p>

                    </div>
                    <button
    onClick={uploadFile}
    disabled={!selectedUser}
    className="mt-2 rounded-xs bg-primary-500 px-4 text-xs py-1.5 font-medium text-white transition hover:bg-primary-700 disabled:cursor-not-allowed disabled:bg-gray-300"
  >
    Wyślij plik
  </button>
                    <CsvUpload fileSelected={(selectedFile)=>setSelectedCSV(selectedFile)}/>
                    <div className={!SelectedCSV ?"hidden":""}>
                    <CompetitionSearchUsers getfoundUsers={(selectedUser)=>setSelectedUser(selectedUser)}/>

                    </div>
                   {/* <CompetitionAddUser users={options.users || []} row={AddindexToUser} saveUserToIndex={saveUserToIndex} /> */}
                {/* <CompetitionUsersAdded users={editing || []} /> */}
                </div>
              </DialogContent>
              <DialogActions>
                                <Button size='medium' onClick={() => setOpenAddMultiIndex(false)} variant="outlined">Zamknij</Button>
                
                {/* <Button size='medium' onClick={() => setOpen(false)} variant="outlined">Anuluj</Button>
                <Button size='medium' onClick={submitForm} variant="contained" color='success'>Zapisz</Button> */}
              </DialogActions>
              </Dialog>
              <div className="w-full rounded-sm p-2 sm:p-2 lg:p-2 border border-gray-200 mb-1 sm:mb-1">
        <div className=" flex-row  sm:flex-row sm:items-end sm:justify-between">
          <div className="grid grid-cols-2 md:grid-cols-[1fr_1fr_auto] gap-3 items-end">
          <Input  label="Szukaj indeksu" value={searchEan} onChange={e => setSearchEan(e.target.value)} size="small" className="w-full text-xs" fullWidth placeholder="Wprowadź EAN lub PN..." />

          <Input label="Szukaj indeksu po nazwie" value={searchName} onChange={e => setSearchName(e.target.value)} size="small" className="w-full text-xs" fullWidth placeholder="Wprowadź nazwę indeksu..." />

          </div>
           
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 sm:gap-3 w-full sm:max-w-full">
           <div className="grid grid-cols-2 md:grid-cols-2 gap-2 sm:gap-3 w-full sm:max-w-full">

           
            <Select label="Aktywność indeksu" 
            value={isActivate} 
            onChange={e => setisActivate(e.target.value)} 
            size="small" fullWidth options={[
              { value: 'all', label: 'Wszystkie' },
              { value: 'activate', label: 'Aktywne' },
              { value: 'noactivate', label: 'Nieaktywne' }
            ]} />
            <Select label="Przypisanie" 
            value={isPrzypisane} 
            onChange={e => setisPrzypisane(e.target.value)} 
            size="small" fullWidth options={[
              { value: 'all', label: 'Wszystkie' },
              { value: 'przypisane', label: 'Przypisane' },
              { value: 'noprzypisane', label: 'Nieprzypisane' }
            ]} />
             
           </div>
 
<div className="grid grid-cols-2 md:grid-cols-[auto_auto] gap-2 sm:gap-3 w-full md:w-fit sm:max-w-full">
            <Button className="h-fit self-end sm:w-auto " variant="outlined" size="small" onClick={() => { clearSearchData(); }}>Wyczyść</Button>
                    <Button className="h-fit self-end sm:w-auto" variant="contained" size="small" onClick={()=>searchDataName()} >SZUKAJ</Button>
</div>

          </div>
         
          <div className="flex gap-2">
          </div>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-auto rounded-sm">
        <BrandlyServiceComponent  loading={loading} data={brandlyData} loadNewData={loadNewData} onEdit={onEdit} onSetUser={onSetUser} onChangeAct={onChangeAc} />
        </div>
      <Snackbar open={toast.open} message={toast.message} onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} />
    </div>
  );
}
